

export function formatPrice(priceString: number) {
    return new Intl.NumberFormat('en-GB', {style: "currency", currency: "GBP"}).format(priceString);
}